import { Component, Input, OnInit, ViewChild, inject, DestroyRef } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { ActivatedRoute, Router } from '@angular/router';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Constants } from 'src/app/models/constants';
import { DeploymentClass } from 'src/app/models/instance-class';
import { Tenant } from 'src/app/models/tenant/tenant';
import { InstancesService } from 'src/app/services/api/instances.service';
import { TenantService } from 'src/app/services/api/tenant.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { GenericErrorComponent } from 'src/app/components/generic-error/generic-error.component';
import moment from 'moment';
import { Permission } from 'src/app/models/principal/permission';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { RouterSegments } from 'src/app/models/router-segments';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';
import { formatAvailabilityState } from 'src/app/services/util/utils';
const REQUIRED_PERMISSIONS = [
  Permission.DR_ACTION
];

@Component({
    selector: 'app-disaster-recovery',
    templateUrl: './disaster-recovery.component.html',
    styleUrls: ['./disaster-recovery.component.scss'],
    animations: [
        trigger('rotate', [
            transition('void=>*', [style({ transform: 'rotate(0)' })]),
            transition('* => *', [
                style({ transform: 'rotate(0)' }),
                animate('650ms ease-in-out', style({ transform: 'rotate(360deg)' })),
            ])
        ])
    ],
    standalone: false
})
export class DisasterRecoveryComponent  implements OnInit {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  
  @Input() blueprint;
  private destroyRef = inject(DestroyRef);
  tenantData: Tenant;
  classAInstaceDetails: any;
  sharedInstanceDetails: any;
  dataLoaded = false;
  Constants = Constants;
  count: any;
  instanceIdsObj: any;
  permissionsMap: { [key: string]: boolean };
  tenantId: any;
  Permission = Permission;
  DeployStatus = DeployStatus;
  isAWS: boolean;
  formatAvailabilityState = formatAvailabilityState;
  DrStates = {
    FAILOVER: "failover",
    PRE_FALLBACK: "pre_fallback",
    FALLBACK: "fallback",
    POST_FALLBACK: "post_fallback"
  }

  DrStatus = {
    FAILOVER_INPROGRESS: "failover_inprogress",
    PRE_FALLBACK_INPROGRESS: "pre_failback_applying",
    FALLBACK_INPROGRESS: "fallback_inprogress",
    POST_FALLBACK_INPROGRESS: "post_failback_applying"
  }

  statusText = {
    failover_inprogress: "Failover In Progress",
    pre_failback_applying: "Pre-Fallback In Progress",
    fallback_inprogress: "Fallback In Progress",
    post_failback_applying: "Post-Fallback In Progress"
  }

  RouterSegments = RouterSegments;

  remainingTime: number;
  DrNotEligibleStatus = [DeployStatus.TERMINATED, DeployStatus.TERMINATING, DeployStatus.TERMINATION_FAILED, DeployStatus.FAILED];

  constructor( private activatedRoute: ActivatedRoute, private tenantService: TenantService,
    private instanceService: InstancesService, private toastrService: CustomToastrService,
    private dialog: MatDialog, public permissionsService: PermissionsService, private router: Router,
    public authService: AuthService) {
    
  }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveUserPermissions(REQUIRED_PERMISSIONS);
    this.tenantService.tenantData$.subscribe((data: any) => {
      this.isAWS = data === CloudProvider.AWS ? true : false;
    });
    this.getTenantDetails();
    const liveInstance = this.blueprint?.pathToLiveConfiguration?.find(item => item.deploymentClass === DeploymentClass.A);
    if (liveInstance && liveInstance?.instanceId) {
      this.getClassAInstanceDetails(liveInstance?.instanceId);
    } else {
      const blueprintId = this.activatedRoute.snapshot.params.blueprintId;
      this.getClassAInstances(blueprintId);
    }
  }

  getTenantDetails(): void {
    this.tenantId = this.activatedRoute.snapshot.params.id;
    this.tenantService.getTenantDetails(this.tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        this.tenantData = data;
        this.sharedInstanceDetails = [];
        this.instanceIdsObj = {
          // sharedInfraInstance: data?.sharedInfra?.prod?.instanceId,
          sharedServicesInstance: data?.sharedServices?.prod?.instanceId
        }
        Object.keys(this.instanceIdsObj).forEach(key => {
          this.getSharedInstanceDetails(this.instanceIdsObj[key]);
        });
      }, (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  getSharedInstanceDetails(id): void {
    this.instanceService.getInstanceDetails(id)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      this.sharedInstanceDetails = [data];
            this.dataLoaded = true;
    }, (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      this.dataLoaded = true;
    });
  }

  getClassAInstanceDetails(instanceId) {
    this.instanceService.getInstanceDetails(instanceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
       this.classAInstaceDetails = [data];
       this.dataLoaded = true;
       setTimeout(() => {
         this.accordion?.openAll();
       }, 100);
    }, (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      this.dataLoaded = true;
      setTimeout(() => {
        this.accordion?.openAll();
      }, 100);
    });
  }

  getClassAInstances(blueprintId): void {
    const instanceObj = {
      blueprintId,
      tenantId: this.tenantId
    }
    this.instanceService.getInstances(instanceObj)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      this.classAInstaceDetails = data?.data?.filter(item => item?.deploymentClass === DeploymentClass.A && item.id);
      this.dataLoaded = true;
      setTimeout(() => {
        this.accordion?.openAll();
      }, 100);
    }, (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      this.dataLoaded = true;
      setTimeout(() => {
        this.accordion?.openAll();
      }, 100);
    });
  }

  startDrAction(instance, section): void {
    let title;
    let message;
    if (!instance?.drState || instance?.drState === this.DrStates.POST_FALLBACK) {
      if ((section === 'shared' && (instance?.status === this.DrStatus.FAILOVER_INPROGRESS || (instance?.drState === this.DrStates.POST_FALLBACK && (this.classAInstaceDetails?.length > 0 && this.classAInstaceDetails[0].drState && (this.classAInstaceDetails[0].drState !== this.DrStates.POST_FALLBACK || this.classAInstaceDetails[0].status === this.DrStatus.POST_FALLBACK_INPROGRESS || this.classAInstaceDetails[0].status === DeployStatus.FAILED))) || !this.checkEligibleStatus(instance?.status))) ||
      (section === 'classA' && (instance?.status === this.DrStatus.FAILOVER_INPROGRESS || (this.sharedInstanceDetails?.length > 0 && (this.sharedInstanceDetails[0].drState !== this.DrStates.FAILOVER || this.sharedInstanceDetails[0].status === this.DrStatus.FAILOVER_INPROGRESS || this.sharedInstanceDetails[0].status === DeployStatus.FAILED)) || !this.checkEligibleStatus(instance?.status))) ) {
        this.openGenericError();
        return;
      } else {
        title = translate('DISASTER_RECOVERY.START_FAILOVER') + ' ?';
        message = translate('DISASTER_RECOVERY.START_FAILOVER_CONFIRMATION');
      }
    } else if (instance?.drState === this.DrStates.FAILOVER) {
      if ((section === 'shared' && (instance?.status === this.DrStatus.PRE_FALLBACK_INPROGRESS || (this.classAInstaceDetails?.length > 0 && (!(this.classAInstaceDetails[0].drState === this.DrStates.FAILOVER || this.classAInstaceDetails[0].drState === this.DrStates.PRE_FALLBACK) || this.classAInstaceDetails[0].status === this.DrStatus.FAILOVER_INPROGRESS || this.classAInstaceDetails[0].status === DeployStatus.FAILED)) || !this.checkEligibleStatus(instance?.status))) ||
      (section === 'classA' && (instance?.status === this.DrStatus.PRE_FALLBACK_INPROGRESS || (this.classAInstaceDetails?.length > 0 && (this.classAInstaceDetails[0].drState !== this.DrStates.FAILOVER || this.classAInstaceDetails[0].status === this.DrStatus.FAILOVER_INPROGRESS || this.classAInstaceDetails[0].status === DeployStatus.FAILED)) || !this.checkEligibleStatus(instance?.status))) ) {
        this.openGenericError();
        return;
      } else {
        title = translate('DISASTER_RECOVERY.START_PREFALLBACK') + ' ?';
        message = translate('DISASTER_RECOVERY.START_FALLBACK_CONFIRMATION');
      }
    } else if (instance?.drState === this.DrStates.PRE_FALLBACK) {
      if ((section === 'shared' && (instance?.status === this.DrStatus.FALLBACK_INPROGRESS || (this.classAInstaceDetails?.length > 0 && (this.classAInstaceDetails[0].drState !== this.DrStates.PRE_FALLBACK || this.classAInstaceDetails[0].status === this.DrStatus.PRE_FALLBACK_INPROGRESS || this.classAInstaceDetails[0].status === DeployStatus.FAILED)) ||
      (this.sharedInstanceDetails?.length > 0 && (this.sharedInstanceDetails[0].drState !== this.DrStates.PRE_FALLBACK || this.sharedInstanceDetails[0].status === this.DrStatus.PRE_FALLBACK_INPROGRESS || this.sharedInstanceDetails[0].status === DeployStatus.FAILED)) || !this.checkEligibleStatus(instance?.status))) ||
      (section === 'classA' && (instance?.status === this.DrStatus.FALLBACK_INPROGRESS || (this.sharedInstanceDetails?.length > 0 && (!(this.sharedInstanceDetails[0].drState === this.DrStates.FALLBACK || this.sharedInstanceDetails[0].drState === this.DrStates.POST_FALLBACK) || this.sharedInstanceDetails[0].status === this.DrStatus.FALLBACK_INPROGRESS || this.sharedInstanceDetails[0].status === DeployStatus.FAILED)) || !this.checkEligibleStatus(instance?.status))) ) {
        this.openGenericError();
        return;
      } else {
        title = translate('DISASTER_RECOVERY.START_FALLBACK') + ' ?';
        message = translate('DISASTER_RECOVERY.START_FALLBACK_CONFIRMATION');
      }
    } else if (instance?.drState === this.DrStates.FALLBACK) {
      if ((section === 'shared' && (instance?.status === this.DrStatus.POST_FALLBACK_INPROGRESS || (this.sharedInstanceDetails?.length > 0 && (this.sharedInstanceDetails[0].drState !== this.DrStates.FALLBACK || this.sharedInstanceDetails[0].status === this.DrStatus.FALLBACK_INPROGRESS || this.sharedInstanceDetails[0].status === DeployStatus.FAILED)) || !this.checkEligibleStatus(instance?.status))) ||
      (section === 'classA' && (instance?.status === this.DrStatus.POST_FALLBACK_INPROGRESS || (this.sharedInstanceDetails?.length > 0 && (this.sharedInstanceDetails[0].drState !== this.DrStates.POST_FALLBACK || this.sharedInstanceDetails[0].status === this.DrStatus.POST_FALLBACK_INPROGRESS || this.sharedInstanceDetails[0].status === DeployStatus.FAILED))
      || (this.classAInstaceDetails?.length > 0 && (this.classAInstaceDetails[0].drState !== this.DrStates.FALLBACK || this.classAInstaceDetails[0].status === this.DrStatus.FALLBACK_INPROGRESS || this.classAInstaceDetails[0].status === DeployStatus.FAILED)) || !this.checkEligibleStatus(instance?.status)))) {
        this.openGenericError();
        return;
      } else {
        title = translate('DISASTER_RECOVERY.START_POSTFALLBACK') + ' ?';
        message = translate('DISASTER_RECOVERY.START_FALLBACK_CONFIRMATION');
      }
    }
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title,
        message,
        confirmButtonText: translate('BUTTONS.SUBMIT')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          if (!instance?.drState || instance?.drState === this.DrStates.POST_FALLBACK) {
            this.startFailover(instance, section);
          } else if (instance?.drState === this.DrStates.FAILOVER) {
            this.startPreFallback(instance, section);
          } else if (instance?.drState === this.DrStates.PRE_FALLBACK) {
            this.startFallback(instance, section);
          } else if (instance?.drState === this.DrStates.FALLBACK) {
            this.startPostFallback(instance, section);
          }
        }
      });
  
  }

  startFailover(instance, section): void {
    this.instanceService.putFailover(instance?.id)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      if (section === 'shared') {
        const index = this.sharedInstanceDetails.findIndex(item => item.id === data.id);
        this.sharedInstanceDetails[index] = data;
      } else if (section === 'classA') {
        const index = this.classAInstaceDetails.findIndex(item => item.id === data.id);
        this.classAInstaceDetails[index] = data;
      }
    }, (error) => {
      const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '342px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: {
          title: translate('ERROR_DIALOG.START_FAILOVER_FAILED'),
          description: errorMessage
        }
      });
    });
  }

  startPreFallback(instance, section): void {
    this.instanceService.putPreFallback(instance?.id)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      if (section === 'shared') {
        const index = this.sharedInstanceDetails.findIndex(item => item.id === data.id);
        this.sharedInstanceDetails[index] = data;
      } else if (section === 'classA') {
        const index = this.classAInstaceDetails.findIndex(item => item.id === data.id);
        this.classAInstaceDetails[index] = data;
      }
    }, (error) => {
      const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '342px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: {
          title: translate('ERROR_DIALOG.START_PREFALLBACK_FAILED'),
          description: errorMessage
        }
      });
    });
  }

  startFallback(instance, section): void {
    this.instanceService.putFallback(instance?.id)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      if (section === 'shared') {
        const index = this.sharedInstanceDetails.findIndex(item => item.id === data.id);
        this.sharedInstanceDetails[index] = data;
      } else if (section === 'classA') {
        const index = this.classAInstaceDetails.findIndex(item => item.id === data.id);
        this.classAInstaceDetails[index] = data;
      }
    }, (error) => {
      const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '342px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: {
          title: translate('ERROR_DIALOG.START_FALLBACK_FAILED'),
          description: errorMessage
        }
      });
    });
  }

  startPostFallback(instance, section): void {
    this.instanceService.putPostFallback(instance?.id)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      if (section === 'shared') {
        const index = this.sharedInstanceDetails.findIndex(item => item.id === data.id);
        this.sharedInstanceDetails[index] = data;
      } else if (section === 'classA') {
        const index = this.classAInstaceDetails.findIndex(item => item.id === data.id);
        this.classAInstaceDetails[index] = data;
      }
    }, (error) => {
       const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '342px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: {
          title: translate('ERROR_DIALOG.START_POSTFALLBACK_FAILED'),
          description: errorMessage
        }
      });
    });
  }

  refreshInstances(): void {
    this.dataLoaded = false;
    this.count = this.count !== 1 ? 1 : 0;
    this.sharedInstanceDetails = [];
    Object.keys(this.instanceIdsObj).forEach(key => {
      this.getSharedInstanceDetails(this.instanceIdsObj[key]);
    });
    const liveInstance = this.blueprint?.pathToLiveConfiguration?.find(item => item.deploymentClass === DeploymentClass.A);
    if (liveInstance && liveInstance?.instanceId) {
      this.getClassAInstanceDetails(liveInstance?.instanceId);
    } else {
      const blueprintId = this.activatedRoute.snapshot.params.blueprintId;
      this.getClassAInstances(blueprintId);
    }
  }
  
   checkEligibleStatus(status): any {
    if (this.DrNotEligibleStatus.includes(status)) {
      return false;
    } else {
      return true;
    }
  }

  openGenericError(): void {
    this.dialog.open(GenericErrorComponent, {
      minHeight: '342px',
      width: '566px',
      panelClass: 'flex-dialog'
    });
  }

  getDifferenceBetweenDates(date): any {
    const todayDate = new Date();
    const remainingTime = Math.round(moment.duration(moment(todayDate).diff(date)).asSeconds());
    return remainingTime < (60 * 5);
  }

  getButtonText(state): any {
    if (state === this.DrStates.FAILOVER) {
      return 'Failover';
    } else if (state === this.DrStates.FALLBACK) {
      return 'Fallback'
    } else if (state === this.DrStates.PRE_FALLBACK) {
      return 'Pre-Fallback'
    } else if (state === this.DrStates.POST_FALLBACK) {
      return 'Post-Fallback'
    }
  }

  retryDrAction(instance, section): void {
    let title;
    let message;
    if (instance?.drState === this.DrStates.FAILOVER) {
      title = translate('DISASTER_RECOVERY.START_FAILOVER') + ' ?';
      message = translate('DISASTER_RECOVERY.START_FAILOVER_CONFIRMATION');
    } else if (instance?.drState === this.DrStates.PRE_FALLBACK) {
      title = translate('DISASTER_RECOVERY.START_PREFALLBACK') + ' ?';
      message = translate('DISASTER_RECOVERY.START_FALLBACK_CONFIRMATION');
    } else if (instance?.drState === this.DrStates.FALLBACK) {
      title = translate('DISASTER_RECOVERY.START_FALLBACK') + ' ?';
      message = translate('DISASTER_RECOVERY.START_FALLBACK_CONFIRMATION');
    } else if (instance?.drState === this.DrStates.POST_FALLBACK) {
      title = translate('DISASTER_RECOVERY.START_POSTFALLBACK') + ' ?';
      message = translate('DISASTER_RECOVERY.START_FALLBACK_CONFIRMATION');
    }
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title,
        message,
        confirmButtonText: translate('BUTTONS.SUBMIT')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          if (instance?.drState === this.DrStates.FAILOVER) {
            this.startFailover(instance, section);
          } else if (instance?.drState === this.DrStates.PRE_FALLBACK) {
            this.startPreFallback(instance, section);
          } else if (instance?.drState === this.DrStates.FALLBACK) {
            this.startFallback(instance, section);
          } else if (instance?.drState === this.DrStates.POST_FALLBACK) {
            this.startPostFallback(instance, section);
          }
        }
      });
  
  }

  public instanceClick(instance): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId,
      RouterSegments.BLUEPRINTS, this.blueprint.id, RouterSegments.ENVIRONMENT, instance.id]);
  }
}
